import * as React from "react";
import { createRoot } from "react-dom/client";
import { Amplify } from "aws-amplify";
import config from "./aws-exports";
import App from "./main/routes";
import { initNewRelic } from "./main/utils/newrelic";

initNewRelic();

Amplify.configure(config);

const container = document.getElementById("app");
const root = createRoot(container!);

root.render(<App />);
